export default "__VITE_PUBLIC_ASSET__0c968f09__"